var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2"},[_c('div',{staticClass:"text-6xl mt-10"},[_vm._v("404")]),_c('div',{staticClass:"text-lg mt-5 font-normal"},[_vm._v("Desculpe, pagina não encontrada.")])])
}]

export { render, staticRenderFns }